module.exports = __webpack_public_path__ + "static/media/pinglunBuss.5ec775c3.svg";